<template>
  <section
    class="tw-border tw-border-primary-grey-100 tw-rounded-md tw-bg-white tw-p-4 tw-shadow-md"
  >
    <ul>
      <li v-for="indicator in indicators" :key="indicator.type" class="tw-mb-4">
        <div class="tw-mb-1">
          <span
            class="tw-font-bold tw-p-1 tw-rounded-sm tw-text-white"
            :class="indicator.colorClass"
          >
            {{ $t(indicator.title) }}
          </span>
        </div>
        <div class="tw-mb-1">{{ $t(indicator.staticDescription) }}</div>
      </li>
    </ul>
  </section>
</template>

<script setup lang="ts">
import { ThreatCoachIndicator } from "../IncidentSummary/ThreatCoach/types/threatCoach";

type Props = {
  indicators: ThreatCoachIndicator[];
};
defineProps<Props>();
</script>
